import { ObjSearchDB } from '../../../../_models/ObjSearchDB.model';

export class Certificati_Pagamento_Filtro extends ObjSearchDB {
	cnt_id: string;
	cnt_old_id: string;
	tipo_lav_id: string;
	reparto_id: string;
	frn_id: string;
	cst_id: string;
	data_da: string;
	data_a: string;
	ctp_id: number;
	ritenuta: boolean;
	/** Lista unica (mode portale): '' tutte, 'general' cantiere, 'em' / 'lo' RFI Emilia-Romagna / Lombardia. */
	origin: string;
	/** Cantiere del certificato (solo mode portale, cert-payment/list ws_id); '-1' = tutti come gli altri filtri. */
	ws_id: string;

	constructor() {
		super();
		this.cnt_id = '-1';
		this.cnt_old_id = '-1';
		this.tipo_lav_id = '-1';
		this.reparto_id = '-1';
		this.frn_id = '-1';
		this.cst_id = '-1';
		this.data_da = '';
		this.data_a = '';
		this.ctp_id = 0;
		this.ritenuta = false;
		this.origin = '';
		this.ws_id = '-1';
	}
}
